import React, {useState, useEffect, useMemo} from "react";
import "./App.css"; // Fichier CSS séparé
import {ReadHebrewText,localStorageSetItem,localStorageGetItem} from "./misc"
import {useLessons} from "./DataContext";
import {useStats} from "./StatsContext"
import SpeakerButton from "./SpeakerButton";
import {removeNekudot} from "./nekudot"

const TextDisplay = ({texts2Display, onBack}) => {

    // Some useful imports */
    const {allLessons} = useLessons();
    const {getFlatTextScore} = useStats();

    // Managing displayed lessons (if -1 --> all are selected)
    const [selectedLesson, setSelectedLesson] = useState(
        texts2Display.selectedLessonsList.length === 1
            ? texts2Display.selectedLessonsList[0]
            : -1);

    // Managing displayed text index
    const [selectedText, setSelectedText] = useState(0);

    // Extract name of the person talking if any
    function extractNameAndPhrase(sentence) {
        const match = sentence[3].match(/^\[(.*?)\s*:?]/);
        const name = match ? match[1].trim() : null;
        const newSentence = sentence.map(str => {
            const match = str.match(/^\[(.*?)\s*:?]\s*(.*)$/);
            if (match)
                return match[2].trim();
            return str.trim();
        });
        return [name, newSentence];
    }

    // The text to be displayed (after being filtered by lesson, and selectedText)
    const [text, setText] = useState([]);
    useEffect(() => {
        let texts = (selectedLesson !== -1
                ? texts2Display.originalContent.filter(t => selectedLesson === t.lesson)
                : texts2Display.originalContent
        );
        let textBlock = [];
        let temp = []
        let lastname = null;
        texts[selectedText].exDataList.forEach((s, index) => {
            const [name,sentence] = extractNameAndPhrase(s)
            if (name === lastname)
                temp.push(sentence);
            else
                temp.push(s);
            lastname = name;
            if (s[2].includes("\u200B") || index === texts[selectedText].exDataList.length - 1) {
                textBlock.push([...temp])
                temp = [];
            }
        })
        if (temp.length !== 0)
            textBlock.push([...temp])
        setText(textBlock)

    }, [selectedLesson, selectedText])

    const sentenceScores = useMemo(() => {
        let texts = (selectedLesson !== -1
                ? texts2Display.originalContent.filter(t => selectedLesson === t.lesson)
                : texts2Display.originalContent
        );
        return texts[selectedText].exDataList.map(exData => getFlatTextScore("versions","hf", exData));
        }, [selectedText]
    );

    // Managing whether nequdots should be displayed
    const [displayNequdot, setdisplayNequdot] = useState(() => {
        return JSON.parse(localStorageGetItem('textDisplayDisplayNequdot')) || false;
    });
    useEffect(() => {
        localStorageSetItem('textDisplayDisplayNequdot', displayNequdot);
    }, [displayNequdot]);
    const handleNequdotToggle = () => {
        setdisplayNequdot(prevState => !prevState);
    };

    const [selected, setSelected] = useState({i: null, j: null});
    const handleClick = (i, j) => {
        setSelected({i, j});
        ReadHebrewText(text[i][j][3])
    }

    const getScore = (i,j) => {
        if (text===null) return
        const index = text.slice(0,i).reduce((acc,v) => acc+v.length,0)
        return Math.round(10*(sentenceScores?.[index+j]))/10
    }

    const onBetweenPhrase = (i,j) => {
        setSelected({i, j});
    }

    /*
     * RENDERING
     */

    return (
        <div className="main-container text-display">
            <div className="title-container top">
                <button className="button-secondary" onClick={() => {
                    onBack();
                }}> ⬅️
                </button>
                <div className="title-container-title">
                    Textes
                </div>
            </div>


            <div className="section-container">

                {/* MENU SELECTED LESSON */}
                <select value={selectedLesson}
                        onChange={(e) => setSelectedLesson(Number(e.target.value))}
                >
                    {texts2Display.selectedLessonsList.length > 1
                        ? <option key={-1} value={-1}>
                            {"Toutes leçons jusqu'à " + allLessons[texts2Display.selectedLessonsList[texts2Display.selectedLessonsList.length - 1]].course}
                        </option>
                        : null
                    }
                    {texts2Display?.selectedLessonsList?.map((lecon, index) => (
                        <option key={texts2Display.selectedLessonsList[index]}
                                value={texts2Display.selectedLessonsList[index]}>
                            {allLessons?.[texts2Display?.selectedLessonsList?.[index]]?.title}
                        </option>
                    ))}
                </select>

                <div className={"section-container-line"}>

                    {/* MENU SELECTED TEXTS */}
                    <select value={selectedText} className={"filtering-element"} style={{textAlign: "right", direction: "rtl"}}
                            onChange={(e) => setSelectedText(Number(e.target.value))}>
                        {texts2Display.originalContent.map((value, index) => (
                            <option key={index} value={index} style={{textAlign: "right", direction: "rtl"}}>
                                {displayNequdot
                                    ? value.title[3]
                                    : removeNekudot(value.title[3])}
                            </option>
                        ))}
                    </select>
                        <SpeakerButton className={"filtering-element"} textsLists={text} onSwitchTextCallBack={onBetweenPhrase} />
                        {/* NEQUDOT BUTTON */}
                        <button id={"nequdot-button"} className={"filtering-element nequdot"} onClick={handleNequdotToggle}>
                            {!displayNequdot ? "נקדות" : "נְקֻדּוֹת"}
                        </button>
                </div>


                <div className="scroll-container" style={{direction: 'rtl'}}>
                    {text.map((block, i) => (
                        <div className="block" key={i}>
                            {block.map((sentence, j) => (
                                <span key={`${i}-${j}`}
                                    className="sentence-wrapper"
                                    onClick={() => handleClick(i, j)}
                                >
                                <span style={{direction: 'rtl'}}>
                                    <sup className={"score-sup " + (getScore(i,j)>0 ? "pos" : (getScore(i,j)< 0 ? "neg" : ""))}>
                                        {getScore(i,j)}
                                    </sup>
                                </span>
                                    <span className={`sentence ${selected.i === i && selected.j === j ? 'selected' : ''}`}>
                                        {displayNequdot ? sentence[3] : removeNekudot(sentence[3])}
                                    </span>
                                </span>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </div>

    );
}

export default TextDisplay;